// Faceted quick-filter model for the Home customer list. Semantics: OR within
// the trend pair, AND across the focus/trend groups; the empty state is "Alle".
export interface QuickFilterState {
  focus: boolean;
  growth: boolean;
  decline: boolean;
}

export const EMPTY_QUICK_FILTER: QuickFilterState = { focus: false, growth: false, decline: false };

export function isQuickFilterEmpty(state: QuickFilterState): boolean {
  return !state.focus && !state.growth && !state.decline;
}

export function toggleQuickFilterKey(state: QuickFilterState, key: string): QuickFilterState {
  if (key === "all") return EMPTY_QUICK_FILTER;
  if (key === "focus" || key === "growth" || key === "decline") {
    return { ...state, [key]: !state[key] };
  }
  return state;
}
